import { Injectable } from '@angular/core';
import { PlannerSearchWorkItemDto } from 'src/app/models/work/planner/planner-search-result.dto';

@Injectable({
  providedIn: 'root'
})
export class SchedulerDragServiceService {
  workItem: PlannerSearchWorkItemDto;
  workItems: PlannerSearchWorkItemDto[];
}
